import React, { useState, useEffect } from 'react';
import { Box, IconButton, Modal, Fade, Backdrop } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AnnouncementPopup = ({ imageSrc, imageAlt = 'Announcement' }) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    let autoCloseTimer = null;

    // Check if we should show the announcement
    const checkAnnouncement = () => {
      try {
        // Check if date is before January 19, 2026
        const expiryDate = new Date('2026-01-19T23:59:59');
        const currentDate = new Date();
        
        if (currentDate > expiryDate) {
          console.log('Announcement expired');
          return; // Don't show if past expiry date
        }

        // Show popup on every page load/refresh
        console.log('Showing announcement popup');
        setOpen(true);
        
        // Auto-close after 10 seconds
        autoCloseTimer = setTimeout(() => {
          handleClose();
        }, 10000);
      } catch (error) {
        console.error('Error checking announcement:', error);
      }
    };

    // Small delay to ensure page is loaded
    const initTimer = setTimeout(checkAnnouncement, 500);
    
    return () => {
      clearTimeout(initTimer);
      if (autoCloseTimer) {
        clearTimeout(autoCloseTimer);
      }
    };
  }, []);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        }
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: 'relative',
            maxWidth: { xs: '90%', sm: '600px', md: '800px' },
            maxHeight: { xs: '90vh', md: '90vh' },
            outline: 'none',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              zIndex: 10,
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 1)',
              },
            }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>

          {/* Image */}
          <Box
            component="img"
            src={imageSrc}
            alt={imageAlt}
            sx={{
              width: '100%',
              height: 'auto',
              display: 'block',
              maxHeight: { xs: '90vh', md: '90vh' },
              objectFit: 'contain',
            }}
          />
        </Box>
      </Fade>
    </Modal>
  );
};

export default AnnouncementPopup;

